export function isSamePathname(pathname: string, otherPathname: string): boolean {
  const pathnameRegExp = new RegExp(`${pathname.trim()}\s*\/?\s*`);
  const otherPathnameRegExp = new RegExp(`${otherPathname.trim()}\s*\/?\s*`);
  return pathnameRegExp.test(otherPathname) || otherPathnameRegExp.test(pathname);
}
